module.exports = __webpack_public_path__ + "img/ff1.c7ca17f9.png";